var render = function render(){var _vm=this,_c=_vm._self._c;return _c('index',{attrs:{"tabelDinamisBeranda":_vm.tabelDinamisBeranda,"tabelDinamisProjectCode":_vm.tabelDinamisProjectCode,"projectName":_vm.projectName}})
}
var staticRenderFns = []

export { render, staticRenderFns }